import { api, RequestOptions } from '@/api/api';
import { ListResponse } from '@/api/index';
import { TrackShare } from '@/types';
import { Route } from 'vue-router';

export interface TrackShareServiceListParams {
  start: number;
  limit: number;
  search?: string;
}

export const TrackShareService = {
  prepareListParams(r: Route, defaultLimit: number): TrackShareServiceListParams {
    const res: TrackShareServiceListParams = {
      start: 0,
      limit: defaultLimit
    };

    if (r.query.start) {
      res.start = parseInt(r.query.start.toString(), 10);
    }

    if (r.query.search) {
      res.search = r.query.search.toString();
    }

    return res;
  },

  list(
    params: TrackShareServiceListParams,
    opts?: RequestOptions
  ): Promise<ListResponse<TrackShare>> {
    return api.get('/track-share', params, opts);
  },

  create(name: string, trackIDs: number[]): Promise<TrackShare> {
    return api.post('/track-share', { name, trackIDs });
  },

  disable(id: number): Promise<TrackShare> {
    return api.post(`/track-share/${id}/disable`);
  },

  enable(id: number): Promise<TrackShare> {
    return api.post(`/track-share/${id}/enable`);
  }
};
